import {
	IRPCRequest,
	IRPCResponse,
} from './types'

import {
	IRPCPublishment,
} from'./publishment';

export const RPCRequestMessageTypeName = 'RPC_REQUEST'
export const RPCResponseMessageTypeName = 'RPC_RESPONSE'
export const RPCPublishmentMessageTypeName = 'RPC_PUBLISHMENT'

export enum RPCMessageType {
  Unknown,
  Request,
  Response,
  Publishment
}

export type ValidRPCMessageTypes = RPCMessageType.Publishment | RPCMessageType.Request  | RPCMessageType.Response

export type RPCMessage = IRPCRequest | IRPCResponse | IRPCPublishment

export interface RPCMessageWrapper {
  messageType: string,
  rpc: RPCMessage
}
